const BidModalConfirmationBody = () => (
    <p className="u-center u-mg-bottom-s">
        Cliquer sur ce bouton vous engage auprès du prestataire sélectionné et une demande de prestation lui sera envoyée.<br/>
        Êtes-vous sûr de vouloir valider vos prestations avec ce prestataire ?
    </p>
)

export default BidModalConfirmationBody